module.exports = __webpack_public_path__ + "static/img/流程管理icon.8ca30a1d.svg";